<template>
  <el-row class="xh-esg-page">
    <el-col :span="24">
      <div class="xh-esg-right-content infoArea">
        <el-row class="xh-esg-page-container" :gutter="20">
          <el-col :span="24">
            <div class="xh-esg-page-item">
              <div class="xh-esg-page-title-content">
                <i></i>
                <div class="xh-esg-page-title">净值走势</div>
              </div>
              <div class="xh-esg-page-chart">
                <e4line
                  url="/esg/assets/MFNetValueTrend"
                  :params="{
                    InnerCode: $route.query.innercode,
                  }"
                  class="xh-esg-page-chart-item"
                  methods="post"
                ></e4line>
              </div>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="xh-esg-page-item">
              <div class="xh-esg-page-title-content">
                <i></i>
                <div class="xh-esg-page-title">阶段涨幅</div>
              </div>
              <div class="xh-esg-page-chart ">
                <el-table
                  v-loading="loading"
                  stripe
                  element-loading-text="数据正在加载中"
                  element-loading-spinner="el-icon-loading"
                  :data="tableData"
                  height="250"
                >
                  <template slot="empty">
                    <div class="noDataTable">暂无数据</div>
                  </template>
                  <el-table-column prop="name" label="阶段" align="center">
                  </el-table-column>
                  <el-table-column prop="upper" label="阶段涨幅" align="center">
                    <template slot-scope="{ row }">
                      <div
                        :class="{
                          'page-table-link': true,
                          red: row.upper > 0,
                          green: row.upper < 0,
                        }"
                      >
                        {{ row.upper | percent }}
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column prop="hs300" label="沪深300" align="center">
                    <template slot-scope="{ row }">
                      <div :class="{
                          'page-table-link': true,
                          red: row.hs300 > 0,
                          green: row.hs300 < 0,
                        }">
                        {{ row.hs300 | percent }}
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="xh-esg-page-item">
              <div class="xh-esg-page-title-content">
                <i></i>
                <div class="xh-esg-page-title">持股行业分布</div>
              </div>
              <div class="xh-esg-page-chart">
                <e4bar2parallel
                  url="/esg/assets/esg_fund_stock_industry"
                  :params="{
                    fund_code: $route.query.ticker,
                    pageNo: 1,
                    pageSize: 8,
                  }"
                  class="xh-esg-page-chart-item"
                  methods="post"
                ></e4bar2parallel>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </el-col>
  </el-row>
</template>

<script>
import { mapActions } from "vuex";
import e4line from "./charts/e4line";
import e4bar2parallel from "./charts/e4bar2parallel";
export default {
  data() {
    return {
      tableData: [],
      loading: false,
    };
  },
  components: {
    e4line,
    e4bar2parallel,
    // e4ring,
  },
  mounted() {
    this.loading = true;
    let {
      query: { innercode: InnerCode },
    } = this.$route;
    this.getRateList({
      InnerCode,
    })
      .then((data) => {
        let tableData = [];
        let itemsMapping = {
          RRInSingleWeek_r: {
            name: "近1周",
            upper: "",
            hs300: "",
          },
          RRInSingleMonth_r: {
            name: "近1月",
            upper: "",
            hs300: "",
          },
          RRInThreeMonth_r: {
            name: "近3月",
            upper: "",
            hs300: "",
          },
          RRInSixMonth_r: {
            name: "近6月",
            upper: "",
            hs300: "",
          },
          RRSinceThisYear_r: {
            name: "今年来",
            upper: "",
            hs300: "",
          },
          RRInSingleYear_r: {
            name: "近1年",
            upper: "",
            hs300: "",
          },
          RRInTwoYear_r: {
            name: "近2年",
            upper: "",
            hs300: "",
          },
          RRInThreeYear_r: {
            name: "近3年",
            upper: "",
            hs300: "",
          },
        };
        let keyMapping = {
          "沪深300": 0,
          "阶段涨幅": 1
        }
        data = data.data;
        data.map((data, index) => {
          let category = data["category"];
          for (const key in itemsMapping) {
            if (Object.hasOwnProperty.call(itemsMapping, key)) {
              const item = itemsMapping[key];
              item[keyMapping[category] ? "upper" : "hs300"] = data[key];
            }
          }
        });
        for (const key in itemsMapping) {
          if (Object.hasOwnProperty.call(itemsMapping, key)) {
            const item = itemsMapping[key];
            tableData.push(item);
          }
        }
        this.tableData = tableData;
      })
      .finally(() => {
        this.loading = false;
      });
  },
  methods: {
    ...mapActions("investInfo/page", {
      getRateList: "GET_RATE_LIST",
    }),
  },
};
</script>
<style lang="scss" scoped>
.xh-esg-page {
  .xh-esg-right-content {
    background-color: #ffffff;
    padding: 0 50px;
    min-height: 520px;

    .xh-esg-page-item {
      padding: 20px 0;
      min-height: 230px;
      .xh-esg-page-title {
        font-size: 14px;
        font-weight: 500;
        color: var(--font_01);
        line-height: 20px;
        display: inline-block;
        vertical-align: middle;
      }
      .xh-esg-page-title-sub {
        font-size: 12px;
        font-weight: 400;
        color: var(--font_01);
        line-height: 17px;
      }
      .xh-esg-page-title-content {
        margin-bottom: 10px;
        i {
          height: 10px;
          width: 10px;
          background-color: #7ad5f4;
          display: inline-block;
          vertical-align: middle;
          margin-right: 8px;
          border-radius: 10px;
        }
      }
      .xh-esg-page-chart {
        height: 250px;
        padding-right: 20px;
        /deep/ .el-table .el-table__cell {
          padding: 2px 0;
          border-bottom: 0;
        }
        /deep/ .el-table::before {
          height: 0;
        }
        .page-table-link {
          text-align: center;
          font-size: 12px;
          &.red {
            color: #fc4b4e;
          }
          &.green {
            color: #2fb856;
          }
        }
        /deep/
          .el-table--striped
          .el-table__body
          tr.el-table__row--striped
          td.el-table__cell {
          // background-color: #f5f6fa;
        }
        /deep/
          .el-table--enable-row-hover
          .el-table__body
          tr:hover
          > td.el-table__cell {
          // background-color: #edf1f5;
        }
      }
    }
  }
}
</style>